import { createFileRoute, useParams } from "@tanstack/react-router";
import { ConnectorCreateForm } from "@/components/portal/connectors/ConnectorCreateForm";

export const Route = createFileRoute("/portal/connectors/$typeSlug/new")({
  component: NewConnectorPage,
});

function NewConnectorPage() {
  const { typeSlug } = useParams({
    from: "/portal/connectors/$typeSlug/new",
  });
  return <ConnectorCreateForm typeSlug={typeSlug} />;
}
